import { useId, useState, type ReactElement, type ReactNode } from 'react';
import './HelpTip.css';

/**
 * The small ? beside a setting's title (2026-09-12 拍板): one tap opens the
 * plain-words explanation of what that setting does, in place, under the
 * title; a second tap closes it. It renders inside the title line, and its
 * open body flows as a block beneath — no floating panel to position on a
 * phone. `which` names the setting on `settings_help_open`.
 */
export function HelpTip({ which, label, children }: {
  which: string;
  /** The setting's title, for the button's accessible name. */
  label: string;
  children: ReactNode;
}): ReactElement {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <>
      <button
        type="button"
        className={`help-tip${open ? ' is-open' : ''}`}
        aria-label={`What does “${label}” do?`}
        aria-expanded={open}
        aria-controls={id}
        data-log="settings_help_open"
        data-log-state={which}
        onClick={() => setOpen((v) => !v)}
      >
        <span aria-hidden>?</span>
      </button>
      {open && <span id={id} className="help-tip-body" role="note">{children}</span>}
    </>
  );
}
